<template>
    <div class="ecologyPage" ref="ecologyPage">
        <!-- 生态市场 -->
        <div class="nav_box">
            <Nav :isClass="isClass" :active="3"></Nav>
        </div>
        <div class="banner">
            <div class="banner_title">API Link，链接产业生态，释放算力价值</div>
            <div class="banner_new">算力资源运营系统面向SaaS应用平台和第三方资源互联互通的开放API接口</div>
        </div>
        <div class="content_box">
            <div class="bg">
                <div class="content_title">
                    <div class="title_top">面向科技前沿的高质量SAAS服务</div>
                    <div class="title_inner">API link inside</div>
                </div>
                <div class="list_box">
                    <div class="list_item" v-for="(item, index) in list" :key="index">
                        <div class="img_box"> <img :src="item.url"></div>
                        <div class="item_inner">
                            <div class="inner_title">{{ item.title }}</div>
                            <div class="inner_content">
                                {{ item.inner }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section6">
            <div class="fort_box">
                <div class="foot_title">共建科技算力服务生态</div>
                <div class="foot_btn">立即咨询</div>
            </div>
        </div>
        <!-- <div class="footer_fout"><Clas></Clas></div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            isClass: false,
            list: [
                 {
                    url: require('../assets/img/page4_2.png'),
                    height: 80,
                    title: '天翼云',
                    inner: '天翼云是中国电信倾力打造的云服务品牌，致力于成为领先的云计算服务提供商。提供云主机、CDN、云电脑、大数据及AI等全线产品和场景化解决方案。'
                }, {
                    url: require('../assets/img/page4_3.png'),
                    height: 76,
                    title: '联通云',
                    inner: '联通云是中国联通旗下的云服务品牌,是全球领先的云计算服务商,为数百万的企业和开发者提供安全可靠、云网一体、专属定制、经济实用、多云协同的高质量云服务。'
                }, {
                    url: require('../assets/img/位图@2x(9).png'),
                    height: 48,
                    title: '移动云',
                    inner: '移动云是中国移动旗下云计算品牌,云网一体/贴身服务/随心定制/安全可控!提供云主机,云电脑,云手机,云数据库,云安全,云存储,舆情等云服务解决方案。'
                }, {
                    url: require('../assets/img/page4_1.png'),
                    height: 46,
                    title: '阿里巴巴',
                    inner: '阿里云创立于2009年，是全球领先的云计算及人工智能科技公司，致力于以在线公共服务的方式，提供安全、可靠的计算和数据处理能力，让计算和人工智能成为普惠科技。',
                }, {
                    url: require('../assets/img/page4_5.png'),
                    height: 76,
                    title: '华为',
                    inner: '华为云是华为的云服务品牌，致力于为全球客户提供领先的公有云服务。包括弹性云服务器、云数据库、云安全、软件开发服务和场景化的解决方案。'
                }, {
                    url: require('../assets/img/page4_6.png'),
                    height: 75,
                    title: '华三',
                    inner: '新华三集团作为数字化解决方案领导者，致力于成为客户业务创新、数字化转型值得信赖的合作伙伴。作为新紫光集团旗下的核心企业，新华三通过深度布局“云-网-安-算-存-端”全产业链，不断提升数字化和智能化赋能水平。'
                }, {
                    url: require('../assets/img/page4_7.png'),
                    height: 69,
                    title: '百度',
                    inner: '百度智能云以“云智一体”为核心赋能千行百业，致力于为企业和开发者提供全球优质的人工智能、大数据和云计算服务以及简单易用的开发工具，加速产业智能化转型升级。'
                }, {
                    url: require('../assets/img/page4_8.png'),
                    height: 61,
                    title: '商汤',
                    inner: '作为人工智能软件公司，商汤科技以“坚持原创，让AI引领人类进步”为使命，旨在持续引领人工智能前沿研究，持续打造更具拓展性更普惠的人工智能软件平台，推动经济、社会和人类的发展，并持续吸引及培养顶尖人才，共同塑造未来。'
                }, {
                    url: require('../assets/img/page4_9.png'),
                    height: 80,
                    title: '中科曙光',
                    inner: '曙光云，中国“城市云”领先品牌，深耕政府信息化20余年，全国建立了50余个云计算中心、服务客户过万。'
                }, {
                    url: require('../assets/img/page4_10.png'),
                    height: 77,
                    title: '浪潮信息',
                    inner: '浪潮云是首批国家机关云服务供应商,作为行业云的引领者,浪潮云致力于成为高品质云服务提供商,具备“专业、生态、可信赖”三大核心优势。'
                }, {
                    url: require('../assets/img/page4_11.png'),
                    height: 72,
                    title: '腾讯',
                    inner: '腾讯云，提供全球领先的云计算、大数据、人工智能等技术产品与服务，以卓越的科技能力打造丰富的行业解决方案，构建开放共赢的合作生态，推动产业互联网建设，助力各行各业实现数字化升级。'
                }, {
                    url: require('../assets/img/page4_12.png'),
                    height: 98,
                    title: '字节',
                    inner: '是最早将人工智能应用于移动互联网场景的科技企业之一。公司以建设“全球创作与交流平台”为愿景。公司的全球化布局始于2015年，“技术出海”是公司全球化发展的核心战略。'
                }, {
                    url: require('../assets/img/page4_13.png'),
                    height: 69,
                    title: '京东',
                    inner: '京东云是京东对外输出技术与服务的核心品牌，致力于为客户提供安全、稳定、高性价比的云服务。提供云主机、云数据库、安全等企业上云产品，并为千行百业提供定制化的数智供应链解决方案。'
                }
            ]
        }
    },
    mounted() {
        window.scrollTo(0, 0)
        let minWidth = window.screen.width;
        this.$refs["ecologyPage"].style.minWidth = minWidth + "px";
        window.addEventListener('scroll', this.mouseWheelHandle, true);
    },
    methods: {
        mouseWheelHandle() {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if (scrollTop > 400) {
                this.isClass = true
            } else {
                this.isClass = false
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.mouseWheelHandle);
    },
}
</script>

<style lang="scss" scoped>
.nav_box {
    position: fixed;
    // position: sticky;
    top: 0;
    z-index: 99;
    width: 100%;
}

.banner {
    width: 100%;
    height: 700px;
    background-image: url("../assets/img/位图@2x (16).png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .banner_title {
        text-align: center;
        font-weight: 500;
        font-size: 28px;
        color: #FFFFFF;
        margin-bottom: 20px;
    }

    .banner_new {
        text-align: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
    }
}

.content_box {
    background-color: #EAEEF0;

    .bg {
        padding: 50px 0;
        background-image: url("../assets/img/bg2_left.png"), url("../assets/img/bg2_right.png");
        background-repeat: no-repeat;
        background-size: 576px 458px;
        background-position: left top, right bottom;
    }

    .content_title {
        text-align: center;
        margin-bottom: 50px;

        .title_top {
            font-weight: 500;
            font-size: 18px;
            color: #333333;
            margin-bottom: 10px;
        }

        .title_inner {
            font-weight: 400;
            font-size: 14px;
            color: #999999;
        }
    }

    .list_box {
        .list_item {
            width: 1200px;
            height: 123px;
            background: #FFFFFF;
            box-shadow: 0px 2 12px 0px rgba(0, 0, 0, 0.1);
            border-radius: 6px;
            padding: 28px 30px;
            display: flex;
            align-items: center;
            margin: auto;
            margin-bottom: 20px;

            .img_box {
                width: 150px;
            }

            img {
                width: 150px;
            }

            .item_inner {
                height: 80px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                border-left: 1px solid #E2E6ED;
                padding-left: 20px;

                .inner_title {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #094990;
                }

                .inner_content {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 12px;
                    color: #6C6C6C;
                }
            }
        }
    }
}

.section6 {
    background-image: url("../assets/img/位图@2x(15).png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 193px;

    .fort_box {
        width: 1260px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .foot_title {
        font-weight: 500;
        font-size: 22px;
        color: #FFFFFF;
    }

    .foot_btn {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 124px;
        height: 40px;
        background: #FFFFFF;
        border-radius: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #094990;

        &:hover {
            background-color: #094990;
            color: #FFFFFF;
        }
    }

}
.footer_fout{
  position: fixed;
  bottom: 10%;
  right: 0;
}
</style>